/* globals window */
const getGlobals = () =>
  typeof window === 'undefined' ? global.GIGPLANET_SETTINGS : window.GIGPLANET_SETTINGS

export default getGlobals
